import React from "react";
import Index from "../views/dashboard/index";
import { Routes, Route } from "react-router-dom";
import IndexCom from "../views/index";

//TransitionGroup
import { TransitionGroup, CSSTransition } from "react-transition-group";

// Dashboard
import Dashboard from "../templates/Dashboad/Dashboard";

import BrandList from "../templates/Brand/BrandsList";

import MetaData from "../templates/MetaData/MetaData";

// Users
import UsersList from "../templates/Users/UsersList";
import ManageUser from "../templates/Users/ManageUser";

// Languages
import LanguagesList from "../templates/Language/LanguagesList";

// directions
import DirectionsList from "../templates/Directions/DirectionsList";

// widgets
import WidgetsList from "../templates/Widgets/WidgetsList";

// Menu
import MenuesList from "../templates/Menu/MenuesList";
import ManageMenu from "../templates/Menu/ManageMenu";

// Author
import AuthorsList from "../templates/Author/AuthorsList";
import ManageAuthor from "../templates/Author/ManageAuthor";

// Albums
import AlbumsList from "../templates/Album/AlbumsList";
import AlbumItems from "../templates/Album/AlbumItems";

// Custom fields Type
import CustomFieldsType from "../templates/Custom Fields/CustomFieldsType";

// Custom fields Data
import CustomFieldData from "../templates/Custom Fields/CustomFieldData";

// contents
import ContentsList from "../templates/Content/ContentsList";
import ManageContent from "../templates/Content/ManageContent";

//Roles
import RolesList from "../templates/Role/RolesList";
import ManageRole from "../templates/Role/ManageRole";
import ManageBrand from "../templates/Brand/ManageBrand";
import SlideList from "../templates/Slides/SlideList";
import ManageSlide from "../templates/Slides/ManageSlide";
import AboutList from "../templates/About/AboutList";
import ManageAbout from "../templates/About/ManageAbout";
import ContactList from "../templates/Contact/ContactList";
import ManageContact from "../templates/Contact/ManageContact";
import ProtectedRoutes from './ProtectedRoutes';

const PrivateRoutes = (props) => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Routes >
          {/* Dashboad */}
          <Route path="/" exact element={<Dashboard />} />

          {/* Users */}
          <Route path="/Users" exact element={<UsersList />} />
          <Route path="/Users/:RouteUserId" exact element={<ManageUser />} />

          <Route path="MetaData/:PageId" element={<MetaData />} />

          {/* Language */}
          <Route path="/Language" exact element={<LanguagesList />} />

          {/* Directions */}
          <Route path="/Directions" exact element={<DirectionsList />} />

          {/* Widgets */}
          <Route path="/Widgets" exact element={<WidgetsList />} />

          {/* Menues */}
          <Route path="/Menu" exact element={<MenuesList />} />
          <Route path="/Menu/:MenuRouteId" exact element={<ManageMenu />} />


          {/* Author */}
          <Route path="/Author" exact element={<AuthorsList />} />
          <Route
            path="/Author/:AuthorRouteId"
            exact
            element={<ManageAuthor />}
          />

          {/* Albums */}
          <Route path="/Album" exact element={<AlbumsList />} />
          <Route path="/Album/:AlbumRouteId" exact element={<AlbumItems />} />

          {/* Custom fields Type */}
          <Route
            path="/CustomFieldsType"
            exact
            element={<CustomFieldsType />}
          />

          {/* Custom fields Data */}
          <Route
            path="/CustomFieldsData/:RouteTypeId"
            exact
            element={<CustomFieldData />}
          />

          {/* Contents */}
          <Route path="/Content" exact element={<ContentsList />} />
          <Route
            path="/Content/:ContentRouteId"
            exact
            element={<ManageContent />}
          />
          <Route path="/Brand" exact element={<BrandList />} />
          <Route
            path="/Brand/:BrandRouteId"
            exact
            element={<ManageBrand />}
          />

          <Route path="/Slides" exact element={<SlideList />} />
          <Route
            path="/Slides/:SlideRouteId"
            exact
            element={<ManageSlide />}
          />
          {/* Roles */}
          <Route path="/Role" exact element={<RolesList />} />
          <Route path="/Role/:RoleRouteId" exact element={<ManageRole />} />

          {/* About */}
          <Route path="/About" exact element={<AboutList />} />
          <Route path="/About/:AboutRouteId" exact element={<ManageAbout />} />


          <Route path="/Contact" exact element={<ContactList />} />
          <Route path="/Contact/:ContactRouteId" exact element={<ManageContact />} />









        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default PrivateRoutes;
